import React, {Component} from "react"
import {Container, Form, Header, Loader} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization, interpolateString, parseMultilineString} from "../utils/localization";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import Steps from "./steps/steps";
import {getStepProps, isAnsel, isAssociationContract, isDistributionChannelIndividual, isSymetra, uiFlowBenAdmin, uiFlowStandalone} from "../utils/common";
import {setValidEmployerPasscode} from "../actions/userActions";
import Footer from "./footer";
import {SupportEmailLink} from "./base";
import {CustomDivider, CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";
import {validateEmployerPasscode} from "../services/services";
import {ValidateEmployerPasscodeRequest} from "../services/types";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData} = state;
    return {
        ...ownProps,
        user: user,
        lang: user.lang,
        initialData: initialData,
        uiFlow: initialData.uiFlow,
        contractType: initialData.contractType,
        distributionChannel: initialData.distributionChannel,
    }
};

class Welcome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
            loading: false,
            employerPasscode: "",
            employerPasscodeValidationError: "",
            hadPasscodeErrors: false,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    componentDidMount() {
        this.props.dispatch(setPrevRoute("/"));
        this.buildSteps();
    }

    buildSteps = () => {
        const {uiFlow, distributionChannel, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    handleEmployerPasscode = async () => {
        const {employerPasscode} = this.state;
        const {initialData} = this.props;
        this.setState({loading: true});
        try {
            const request = new ValidateEmployerPasscodeRequest({
                token: initialData.token,
                employerPasscode,
            })
            const {status, statusText} = await validateEmployerPasscode(request);
            if (status !== 200) {
                this.setState({
                    loading: false,
                    employerPasscodeValidationError: statusText,
                    hadPasscodeErrors: true,
                })
            } else {
                await this.props.dispatch(setValidEmployerPasscode());
                this.props.history.push(this.props.nextRoute);
            }
        } catch (e) {
            let msg = e.message;
            if (!!e && !!e.response && !!e.response.data) {
                msg = e.response.data;
            }
            this.setState({
                loading: false,
                employerPasscodeValidationError: msg,
                hadPasscodeErrors: true,
            })
        }
    }

    handleNext = () => {
        const {uiFlow} = this.props.initialData;
        if (uiFlow === uiFlowBenAdmin) {
            this.handleEmployerPasscode().then()
        } else {
            this.props.history.push(this.props.nextRoute)
        }
    }

    render() {
        const {stepProps, loading, hadPasscodeErrors, employerPasscode, employerPasscodeValidationError} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const {contractInfo: {employerName}, uiFlow} = this.props.initialData;
        const {firstName} = this.props.user;
        const {contractType, distributionChannel} = this.props;
        const isAssociation = isAssociationContract(contractType);
        const isIndividual = isDistributionChannelIndividual(distributionChannel);
        const localization = getLocalization(this.props.lang);
        const colWidth = isIndividual ? 12 : 8;
        let strings = localization.welcome;
        let titleHeader = 'h1';
        let textAlign = 'center';
        let subtitle = parseMultilineString(strings.subTitle, [employerName])
        const isBenAdmin = uiFlow === uiFlowBenAdmin;
        if (isBenAdmin) {
            strings = localization.benAdminWelcome;
            titleHeader = 'h2';
            textAlign = 'left';
        }
        if (isIndividual) {
            strings = localization.individualWelcome;
            titleHeader = 'h1';
            textAlign = 'center';
            subtitle = parseMultilineString(strings.subTitle, [employerName])
        }

        return (
            <React.Fragment>
                <Container className={isSymetra() && 'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                
                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`}>
                        <CustomGrid.Row style={{padding: 0}}>
                            <CustomGrid.Column textAlign='center' style={{padding: 0}}>
                                <S3Image {...IMAGE.WELCOME}/>
                                <CustomDivider hidden/>
                            </CustomGrid.Column>
                            <CustomGrid.Column width={colWidth} textAlign={textAlign} style={{padding: 0}}>
                                <Header as={titleHeader} content={<span dangerouslySetInnerHTML={{__html: interpolateString(strings.title, [firstName])}}></span>}/>
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                        <CustomGrid.Row>
                            <CustomGrid.Column width={colWidth} textAlign={textAlign} style={{padding: 0}}>
                                {uiFlow === uiFlowStandalone && <Header className={'neutral900Text'} as='h4' style={{fontSize: '1.11rem'}}>{subtitle}</Header>}
                                {uiFlow === uiFlowBenAdmin && <b>{subtitle}</b>}
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                        <CustomGrid.Row style={{paddingTop: 0}}>
                            <CustomGrid.Column className={"neutral700Text"} textAlign={textAlign} width={colWidth} style={{padding: 0}}>
                                <p style={{fontSize: '16px'}}>{parseMultilineString(strings.description)}</p>
                            </CustomGrid.Column>
                        </CustomGrid.Row>

                        {!!isBenAdmin &&
                        <CustomGrid.Row style={{textAlign: isIndividual ? 'center' : 'left', padding: 0}}>
                            <CustomGrid.Column width={isIndividual ? 8 : colWidth} style={{padding: 0}}>
                                <Form>
                                    <Form.Field required>
                                        <Form.Input value={employerPasscode} className={'inputEmployerPasscode'}
                                                    label={isIndividual ? strings.passcode : isAssociation ? strings.associationPasscode : strings.employerPasscode}
                                                    error={employerPasscodeValidationError.length > 0}
                                                    onChange={(e, {value}) => {
                                                        this.setState({
                                                            employerPasscode: value,
                                                            employerPasscodeValidationError: ''
                                                        });
                                                    }}
                                        />
                                        {employerPasscodeValidationError.length > 0 &&
                                            <span className={"errorText small"}>{strings.thatPasscode}</span>}
                                    </Form.Field>
                                </Form>
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                        }
                        {!!isBenAdmin &&
                        <CustomGrid.Row style={{textAlign: isIndividual ? 'center' : 'left'}}>
                            <CustomGrid.Column width={isIndividual ? 8 : colWidth} style={{padding: 0}}>
                                {!!hadPasscodeErrors && <div>
                                    <div><b>{strings.stillHavingTr}</b></div>
                                    <p>{isAssociation ? strings.checkWithYourAssociation : strings.checkWithYour}<br/>
                                        {strings.or}{' '}<SupportEmailLink/>
                                    </p>
                                </div>}
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                        }
                    </CustomGrid>
                </Container>
                <Footer
                    buttonText={strings.nextButton}
                    disabled={isBenAdmin ? !employerPasscode || employerPasscode.length === 0 || !!employerPasscodeValidationError : false}
                    hideLimitationsAndExclusions={true}
                    loading={loading}
                    onClickCallback={this.handleNext}
                    showTopFooter={true} showCenterData={true}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Welcome));
